import { Trans } from '@lingui/react/macro';
import { cn } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { useCurrentBrand } from '../../stores/BrandStore/brandStore';
import { BrandImage } from '../Brand/BrandImage';
import { NewBookingButton } from './NewBookingButton';

type Variant = 'justActivated' | 'alreadyLinked';

type Props = {
  variant?: Variant;
  className?: string;
};

export const BenefitsActivatedCard = ({ variant = 'justActivated', className }: Props) => {
  const { currentBrand } = useCurrentBrand();

  const description =
    variant === 'alreadyLinked' ? (
      <p className='text-sm text-muted-foreground'>
        <Trans>
          The benefits have already been linked to your account, and discounts will be automatically applied to your
          shopping cart
        </Trans>
      </p>
    ) : (
      <p className='text-sm text-muted-foreground'>
        <Trans>You can now make a new booking with your benefits.</Trans>
      </p>
    );

  return (
    <NoddiBasicCard className={cn('overflow-hidden', className)}>
      <div className='flex flex-col gap-4 md:flex-row md:items-center md:gap-6'>
        <div className='flex min-w-0 flex-1 flex-col gap-3'>
          <p className='font-semibold text-primary'>
            <Trans>The benefits have been activated!</Trans>
          </p>
          {description}
          <NewBookingButton className='w-full md:w-fit' />
        </div>
        <div className='h-32 w-full shrink-0 overflow-hidden rounded-lg md:h-36 md:w-44 lg:w-52'>
          <BrandImage brand={currentBrand} className='size-full object-cover object-center' />
        </div>
      </div>
    </NoddiBasicCard>
  );
};
